module.exports = __webpack_public_path__ + "community_person.cf2a7c34.png";